import { gql } from '@/__generated__';
import Video from '@/components/Video';
import { createBlock } from '@/lib/parsers/blocks';
import { BlockContainer } from '../..';

export const VIDEO_BLOCK_FRAGMENT = gql(`
  fragment videoBlock on blocks_video_BlockType {
    videoUrl
  }
`);

const VideoBlock = createBlock(VIDEO_BLOCK_FRAGMENT, ({ data, meta }) => {
  const { videoUrl } = data;

  return (
    <BlockContainer meta={meta} marginY>
      <Video videoUrl={videoUrl} />
    </BlockContainer>
  );
});

export default VideoBlock;
